'use strict';

angular.module('imagetrend.components')
    .directive('hlpInput', ['$timeout', 'Format', 'Validation', function ($timeout, Format, Validation) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=',
                validation: '=?',
                loading: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                size: '@?',
                type: '@?',
                maxLength: '@?',
                modal: '@?',
                placeholder: '@?',
                hideLabel: '@?',
                ariaLabel: '@?',
                autoComplete: '@?',

                //disabled
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                entireWidth: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/input/input.html',
            controller: ['$scope', function ($scope) {
                $scope.validateQuestion = function () {
                    Validation.validateQuestion($scope.innerForm[$scope.name], $scope.validation, $scope.ngModel).then(function (result) {
                        $scope.loading = false;
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !result || !isEmpty($scope.innerForm[$scope.name].$error) || !isEmpty($scope.innerForm.$error);
                        }
                    });
                }

                var initialValidated = false;
                var unregValueWatch = $scope.$watch(function () {
                    return $scope.question && $scope.question.answer ? $scope.question.answer.value : undefined;
                }, function (newVal) {
                    if (!initialValidated && newVal !== undefined) {
                        initialValidated = true;
                        $scope.validate();
                        unregValueWatch();
                    }
                });

                $scope.validate = function () {
                    if ($scope.question && $scope.question.loading) {
                        var unregLoading = $scope.$watch('question.loading', function (loading) {
                            if (loading === false) {
                                $scope.validate();
                                unregLoading();
                            }
                        });
                        return;
                    }

                    if ($scope.innerForm !== undefined) {
                        if ($scope.type == 'email' && $scope.ngModel != null && $scope.ngModel.length > 0) {
                            var valid = /^[a-z0-9._%+!#$&'*/=?^`{|}~-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i.test($scope.ngModel);
                            $scope.innerForm[$scope.name].$setValidity("email", valid);
                        }
                        if ($scope.type == 'mmyyyy' && $scope.ngModel != null && $scope.ngModel.length > 0) {
                            var valid = /^(0[1-9]|1[012])-\d{4}$/i.test($scope.ngModel);
                            $scope.innerForm[$scope.name].$setValidity("mmyyyy", valid);
                        }
                        if ($scope.type == 'numberRegex' && $scope.ngModel != null && $scope.ngModel.length > 0) {
                            var valid = /^[0-9]*$/i.test($scope.ngModel);
                            $scope.innerForm[$scope.name].$setValidity("numberRegex", valid);
                        }

                        if ($scope.validation) {
                            $scope.validateQuestion();
                        }
                    }
                }

                var validationTimeout = $timeout(function () {
                    if (!$scope.requiredText) {
                        $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name));
                    }
                    $scope.validate();
                }, 0);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                    if (unregValueWatch) { unregValueWatch(); }
                });
            }],
            link: function (scope, elem, attrs, ctrl) {
                scope.autoComplete = attrs.autoComplete;

                //attributes
                if (!attrs.name) { attrs.name = 'input'; }
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.size) { attrs.size = '35'; }
                if (!attrs.type) { attrs.type = 'text' }
                if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }
                if (!attrs.maxLength) { attrs.maxLength = '5000'; } else { if (attrs.maxLength == '') attrs.maxLength = '5000'; }
                if (attrs.hideLabel === undefined || attrs.hideLabel === null) { attrs.hideLabel = false }

                //label
                var wasEmpty = attrs.label == 'EMPTY';
                if (!attrs.label) { attrs.label = Format.label(attrs.name); } else { if (attrs.label == 'EMPTY') { attrs.label = ''; } }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0 || wasEmpty; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }

                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                //if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label(attrs.label || attrs.name) }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                /*
                scope.validationFocus = function () {
                    // if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label(scope.label || scope.name) }

                    // new way of doing this
                    angular.element(elem[0]).on('focus', 'ng-form', function () {
                        scope.firstInvalid = elem[0].querySelector('input');
                        if (scope.firstInvalid) {
                            scope.firstInvalid.focus();
                        }
                    });

                    // old way of doing this
                    elem[0].querySelector('ng-form').focus = function () {
                        scope.firstInvalid = elem[0].querySelector('input');
                        if (scope.firstInvalid) {
                            scope.firstInvalid.focus();
                        }
                    }
                };

                var validationFocusTimeout = $timeout(function () {
                    scope.validationFocus();
                }, 0);
                */

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.type == 'email' && scope.ngModel != null && scope.ngModel.length > 0) {
                        var valid = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i.test(scope.ngModel);
                        scope.innerForm[scope.name].$setValidity("email", valid);
                    }
                    if (scope.type == 'mmyyyy' && scope.ngModel != null && scope.ngModel.length > 0) {
                        var valid = /^(0[1-9]|1[012])-\d{4}$/i.test(scope.ngModel);
                        scope.innerForm[scope.name].$setValidity("mmyyyy", valid);
                    }
                    if (scope.type == 'numberRegex' && scope.ngModel != null && scope.ngModel.length > 0) {
                        var valid = /^[0-9]*$/i.test(scope.ngModel);
                        scope.innerForm[scope.name].$setValidity("numberRegex", valid);
                    }
                    if (scope.ngModel == null) {
                        scope.innerForm[scope.name].$setValidity("mmyyyy", true);
                        scope.innerForm[scope.name].$setValidity("numberRegex", true);
                    }
                    if (scope.validation) {
                        scope.validateQuestion();
                    }

                }

                scope.getClasses = function () {
                    if ((!scope.showLabel && !scope.modal && !scope.topLabel) || scope.topLabel) {
                        return 'no-label col-lg-' + scope.getWidth(12) + ' col-xs-' + scope.getWidth(12);
                    }
                    else if (scope.showLabel && !scope.modal && !scope.topLabel) {
                        return 'col-xs-' + scope.getWidth(9) + ' col-lg-' + scope.getWidth(10);
                    }
                    else if (scope.modal && !scope.topLabel) {
                        return 'col-xs-' + scope.getWidth(9);
                    }
                }

                if (scope.question !== undefined) {
                    // watch for signal to refresh the validation
                    scope.$watch('question.refreshValidation', function (refresh) {
                        scope.$evalAsync(function () {
                            if (refresh) {
                                scope.validateQuestion();
                            }
                            scope.question.refreshValidation = null;
                        });
                    }, true);
                }

                scope.getWidth = function (max) {
                    if (scope.entireWidth) {
                        return max;
                    }
                    else {
                        var max_length = (scope.validation != null) ? scope.validation.max_length || scope.maxLength : scope.maxLength;
                        if (max_length == null || max_length == 0) {
                            return max;
                        }
                        return Math.max(Math.min(Math.ceil(max_length / max), max), 2);
                    }
                }
                //ctrl.$viewChangeListeners.push(function () {
                //    scope.$eval(attrs.ngChange);
                //});

                scope.submitted = false;
                scope.onFormSubmit = scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    scope.onFormSubmit();
                    // $timeout.cancel(validationFocusTimeout);

                    // scope.firstInvalid = undefined;
                    // elem[0].querySelector('ng-form').focus = undefined;

                    // when scope.$destroy is executed, it will remove all listeners registered via $on on scope, but it will NOT remove $rootScope listeners
                    // which must be unregistered manually

                    // when scope.$destroy is executed, it will remove all listeners registered via $on on scope, but it will NOT remove $rootScope listeners
                    // which must be unregistered manually

                    // when element.remove() is executed that element and all of its children will be removed from the DOM together with all event handlers
                    // attached via element.on, it will NOT destroy the scope associated with the element

                    // angular.js removes $$watchers when scope's $destroy method is call, so we SHOULD NOT have to do this manually
                });
            }
        };
    }])

;